import SelectTags from './SelectTags';

export default SelectTags;
